import React from 'react'
import { Row, Col, Dropdown, Menu, Icon } from 'antd';
// import $ from 'jquery';
import { Link } from 'react-router-dom';


class NavbarUnder extends React.Component {
  render() {
    const menu = (
      <Menu>
        <Menu.Item key="0">
          <a target="_blank" rel="noopener noreferrer" href="/">Profile</a>
        </Menu.Item>
        <Menu.Item key="1">
          <a target="_blank" rel="noopener noreferrer" href="/stuff-contact-list">Home Dashboard</a>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="3">
          <Link rel="noopener noreferrer" to="/signin">Logout</Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="navbar-under-wrap">
        <Row className="navbar" >
          <Col className="navbar-image">
            <img src="http://www.uplevo.com/images/ver2.1/logo.png" alt="Uplevo Logo" />
          </Col>
          <Col className="navbar-links">
            <ul>
              <li><Link to="/stuff-contact-list">Danh sách Contact</Link></li>
              <li>
                <Dropdown overlay={menu}>
                  <a className="ant-dropdown-link" href="#">
                    Hi {sessionStorage.getItem('username')} <Icon type="down" />
                  </a>
                </Dropdown>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
}
export default NavbarUnder;


// WEBPACK FOOTER //
// ./src/components/Staff/NavbarUnderStaff.js